import React, {useContext} from 'react'
import {makeStyles} from '@material-ui/core';
import Tile from 'components/Tile';
import ForumIcon from '@material-ui/icons/Forum'
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary'
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import GavelIcon from '@material-ui/icons/Gavel';
import InfoIcon from '@material-ui/icons/Info';
import Tr from 'translations/Translations';
import RouterPath from "libs/RouterPath";
import {useParams, withRouter} from "react-router";
import {StageSections, StageSectionsUrlParams} from "../constants/StageSections";
import openInNewTab from "libs/openInNewTab";
import {DemandValidationSectionStatus} from "constants/DemandValidationSectionStatus";
import OfferStageTranslationsContext from "context/OfferStageTranslationsContext";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        '&>*:not(:first-child)': {
            marginLeft: theme.spacing(2),
        },
        marginBottom: theme.spacing(4)
    },
    icon: {
        fontSize: theme.components.icon.fontSize,
    },
    mirror: {
        transform: 'scaleX(-1)'
    },
    tile: {
        width: 225,
        height: 203,
    },
    highlight: {
        color: theme.palette.primary.main
    }
}));

function OfferTilesRow(
    {
        dashboardSection,
        demandStageSectionsList
    }) {
    const classes = useStyles();
    const params = useParams();
    const demandId = params.id;
    const stageId = params.stageId;
    const stageTr = useContext(OfferStageTranslationsContext);

    const handleOfferFormClick = () => {
        const sectionsToSearch = [StageSections.AUCTION_OFFER_EDIT, StageSections.ADDITIONAL_OFFER_EDIT, StageSections.OFFER_EDIT];
        const section = sectionsToSearch.find(x => demandStageSectionsList[x] && demandStageSectionsList[x].status !== DemandValidationSectionStatus.UNAVAILABLE);
        if (section) {
            RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.ctrDemand.steps.CTR_DEMAND_ID_OFFER_STAGE_ID_SECTION,
                {id: demandId, stageId, section: StageSectionsUrlParams[section]}), {scrollTo: true})
        }
    }

    const getMessagesLabel = () => {
        let label = Tr('messages');
        if (dashboardSection.messagesCount != null && dashboardSection.unreadMessagesCount != null) {
            label += `<br/>${dashboardSection.unreadMessagesCount} / ${dashboardSection.messagesCount}`
        }
        return label;
    }

    return (
        <>
            <div className={classes.root}>
                <Tile
                    className={classes.tile}
                    icon={<InfoIcon className={classes.icon}/>}
                    text={Tr('basic_data_adn_documents')}
                    dangerouslySetText
                    onClick={(e) => {
                        RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.ctrDemand.steps.CTR_DEMAND_ID_OFFER_STAGE_ID_SECTION,
                            {id: demandId, stageId, section: StageSectionsUrlParams.GENERAL_INFO}), {scrollTo: true})
                    }}
                />
                <Tile
                    className={classes.tile}
                    icon={<GavelIcon className={classes.icon}/>}
                    text={stageTr("offer_form")}
                    onClick={handleOfferFormClick}
                />
                <Tile
                    className={classes.tile}
                    icon={<CheckCircleIcon className={classes.icon}/>}
                    text={Tr("check_signature")}
                    onClick={(e) => {
                        openInNewTab(dashboardSection.digitalSignCheckUrl)
                    }}
                />
                <Tile
                    className={classes.tile}
                    icon={<LocalLibraryIcon className={classes.icon}/>}
                    text={Tr('knowlage_base') + "<br/><br/>"}
                    dangerouslySetText
                    onClick={(e) => {
                        openInNewTab(dashboardSection.publicKnowledgeBaseUrl);
                    }}
                />
                <Tile
                    className={clsx(classes.tile, {[classes.highlight]: dashboardSection.unreadMessagesCount > 0})}
                    icon={<ForumIcon className={classes.icon}/>}
                    text={getMessagesLabel()}
                    dangerouslySetText
                    onClick={(e) => {
                        RouterPath.redirect(RouterPath.createPath(RouterPath.ctrDemand.steps.CTR_DEMAND_ID_CORRESPONDENCE, {id: demandId}))
                    }}
                />
            </div>
        </>
    )
}

OfferTilesRow.propTypes = {}

OfferTilesRow.defaultProps = {}


export default withRouter(OfferTilesRow);